// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
// Sibling imports
const collectionSelectModalActions = require('./actions')
const CollectionSelectModal = require('./component-dumb')
const selectors = require('./selectors')

function mapStateToProps(state) {
  if (!selectors.isVisible(state) || selectors.isLightweightModalVisible(state)) {
    return {
      isVisible: false
    }
  }
  return {
    // Flags
    isArticleFailed: selectors.isArticleFailed(state),
    isArticleLoaded: selectors.isArticleLoaded(state),
    isCommentDisabled: selectors.isCommentPending(state),
    isCommentVisible: state.user.hasRollout('collection_select_modal_comment_form'),
    isCreateButtonDisabled: selectors.isCreatePending(state),
    isCreateButtonVisible: selectors.canCreateFromFilter(state),
    isCollectionsLoaded: selectors.isCollectionsLoaded(state),
    isCollectionsFailed: selectors.isCollectionsFailed(state),
    isFilteredCollectionsEmpty: selectors.isFilteredCollectionsEmpty(state),
    isUnfilteredCollectionsEmpty: selectors.isUnfilteredCollectionsEmpty(state),
    isUnmixDisabled: selectors.isUnmixPending(state),
    isUnmixPromptVisible: selectors.isUnmixPromptVisible(state),
    isUnmixVisible: selectors.isUnmixVisible(state),
    isVisible: true,
    // Values
    article: selectors.article(state),
    collections: selectors.filteredCollections(state),
    commentText: selectors.commentText(state),
    filterText: selectors.filterText(state)
  }
}

const mapDispatchToProps = {
  onDismiss: collectionSelectModalActions.hide,
  onCreateClick: collectionSelectModalActions.createCollectionFromFilter,
  onCollectionClick: collectionSelectModalActions.toggleCollection,
  onCommentSubmit: collectionSelectModalActions.submitComment,
  onCommentTextChange: collectionSelectModalActions.setCommentText,
  onFilterTextChange: collectionSelectModalActions.setFilterText,
  onRetryClick: collectionSelectModalActions.fetch,
  onUnmixClick: collectionSelectModalActions.showUnmixPrompt,
  onUnmixPromptCancel: collectionSelectModalActions.cancelUnmix,
  onUnmixPromptConfirm: collectionSelectModalActions.confirmUnmix
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    CollectionSelectModal
  )
)
